<template>
  <v-container fluid>
    <section>
      <v-card class="ps-card-soft">
        <div class="d-flex align-center justify-space-between flex-wrap py-3 px-4">
          <div
            class="ps-sort-title"
            :class="{ 'white--text': $vuetify.theme.dark }"
          >
            {{ $t("sort_product") }}
          </div>

          <div class="d-flex justify-end align-center sort-toggle-wrapper">
            <v-btn-toggle
              v-model="sortType"
              mandatory
              dense
              class="ps-status-toggle sort-tabs-toggle"
              @change="resetSort"
            >
              <v-btn
                v-for="(item, index) in sortList"
                :key="index"
                small
                :value="item.value"
                class="sort-tab-btn"
              >
                <v-icon v-if="item.icon" small class="mr-1">{{ item.icon }}</v-icon>
                {{ $t(item.value) }}
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>
        <v-card-text class="py-0 px-4">
          <main class="page page--table">
            <v-data-table
              :headers="headers"
              :items="sortProducts.data"
              :items-per-page="options.itemsPerPage"
              :loading="loading"
              item-key="id"
              :show-select="false"
              hide-default-footer
              fixed-header
              class="page__table"
            >
              <template v-slot:body="props">
                <draggable
                  :list="props.items"
                  tag="tbody"
                  @change="handleChange"
                >
                  <tr v-for="(item, index) in sortProducts.data" :key="index">
                    <td>{{ item.number }}</td>
                    <td>{{ item.code }}</td>
                    <td>
                      <v-avatar
                        tile
                        size="40"
                        class="rounded-lg"
                        color="grey lighten-2"
                      >
                        <app-img :img="item.img" />
                      </v-avatar>
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.stock }}</td>
                    <td>
                      {{ getCategoryName(item.category) }}
                    </td>
                    <td>
                      {{ priceWithCurrency(item.price_sale, item.currency) }}
                    </td>
                    <td class="text-right">
                      {{ item.created_at | moment }}
                    </td>
                  </tr>
                </draggable>
              </template>
              <template v-slot:footer>
                <v-data-footer
                  :options.sync="options"
                  :pagination.sync="page"
                  :items-per-page-options="rowsPerPageItems"
                  items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                >
                  <template v-slot:page-text="pagetext">
                    {{ footerPage(pagetext) }}
                  </template>
                </v-data-footer>
              </template>
            </v-data-table>
          </main>
        </v-card-text>
      </v-card>
    </section>
  </v-container>
</template>
<script>
import Draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import { sortProductHead } from "@/utils/head";
import { toast } from "@/controllers/alert";
import { myMixin } from "@/mixin/main";

export default {
  layout: "product",
  components: { Draggable },
  mixins: [myMixin],

  data: () => ({
    tableItems: [],
    loading: false,
    sortType: "new_arrivals",
    sortList: [
      {
        text: "New Arrivals",
        icon: "fal fa-clock",
        value: "new_arrivals",
      },
      {
        text: "Barcode",
        icon: "fal fa-barcode",
        value: "barcode",
      },
      {
        text: "Best Selling",
        icon: "fal fa-chart-bar",
        value: "best_selling",
      },
    ],
    options: {
      page: 1,
      itemsPerPage: 50,
    },
  }),

  created() {
    this.fetchProduct();
  },
  mounted() {
    const sort = localStorage.getItem("sort");
    if (sort) {
      this.sortType = sort;
    }
  },
  computed: {
    ...mapGetters({
      sortProducts: "index/sortProducts",
      rowsPerPageItems: "index/rowsPerPageItems",
    }),
    headers() {
      return sortProductHead(this);
    },

    page() {
      const body = {
        page: this.sortProducts.current_page,
        itemsPerPage: this.sortProducts.per_page,
        pageStart: this.sortProducts.from,
        pageStop: this.sortProducts.to,
        pageCount: this.sortProducts.per_page,
        itemsLength: this.sortProducts.total,
      };
      return body;
    },
  },
  watch: {
    options(next, pre) {
      const path = this.sortProducts.path;
      // split path to get only the path
      const splitPath = path.split("/");
      // get the last index of the path
      const lastIndex = splitPath.length - 1;
      // get the path
      const url = `${splitPath[lastIndex]}`;
      // set the per page
      const data = {
        url: `${url}?page=${next.page}&per_page=${next.itemsPerPage}`,
        commit: "SET_SORT_PRODUCTS",
        that: this,
      };
      // called the pagination action
      this.fetch(data);
      this.value = true;
    },
  },
  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchProduct() {
      const body = {
        that: this,
        url: `products_paginate?page=${this.options.page}&per_page=${this.options.itemsPerPage}`,
        commit: "SET_SORT_PRODUCTS",
      };
      await this.fetch(body);
    },
    footerPage(val) {
      const start = val.pageStart;
      const stop = val.pageStop;
      const total = val.itemsLength;
      return `${start > 2 ? start - 2 : start - 1} - ${stop} of ${total}`;
    },
    async handleChange({ moved }) {
      const { newIndex, element } = moved;
      const form = {
        oldIndex: element.number,
        newIndex: newIndex + 1,
        id: element.id,
      };
      try {
        const { data } = await this.$http.post("products_sort", form);
        if (data.status) {
          await toast(this, data.message);
          await this.fetchProduct();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async resetSort(sort) {
      try {
        const form = {
          sort: sort,
        };
        const { data } = await this.$http.post("products_sort_reset", form);
        if (data.status) {
          await toast(this, data.message);
          await this.fetchProduct();
          localStorage.setItem("sort", sort);
          this.sortType = sort;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getProductTypeLabel(item) {
      const { has_variations, track_stock, is_bundle } = item;
      let label = "regular";
      if (has_variations) {
        label = "variant";
      } else if (track_stock) {
        label = "regular";
      } else if (is_bundle) {
        label = "bundle";
      }
      return this.$t(label);
    },
    getProductTypeColor(item) {
      const { has_variations, track_stock, is_bundle } = item;
      if (has_variations) {
        return "blue";
      } else if (track_stock) {
        return "green";
      } else if (is_bundle) {
        return "purple";
      }
      return "green";
    },
  },
};
</script>

<style scoped>
.ps-sort-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}

.theme--dark .ps-sort-title {
  color: #ffffff !important;
}

.ps-card-soft {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px !important;
  box-shadow: none !important;
  transition: box-shadow 0.15s ease;
}

.theme--dark .ps-card-soft {
  background: #1e1e2d !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

.sort-tabs-toggle {
  padding: 4px !important;
  height: 40px !important;
  gap: 6px !important;
}

.sort-tabs-toggle .sort-tab-btn {
  padding: 0 18px !important;
  height: 32px !important;
  font-size: 13px !important;
}

@media (max-width: 600px) {
  .sort-toggle-wrapper {
    width: 100%;
    margin-top: 8px;
  }
  .sort-tabs-toggle {
    width: 100%;
  }
  .sort-tabs-toggle .sort-tab-btn {
    flex: 1;
    padding: 0 10px !important;
  }
}
</style>
